import React from 'react';
import { isEmpty } from 'lodash';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';
import { useTranslation } from '@hooks/index';

type SubjectReviewLogAuditRecord = {
    Type?: number;
    DataSetDate?: string;
};

const fieldsToHide: string[] = ['LeftAxis', 'RightAxis', 'DatasetId', 'DecisionId', 'IsDeleted', 'Type', 'DataSetDate'];

const SubjectReviewLogsAuditLogGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    if (isEmpty(oldRecord) && isEmpty(newRecord)) return null;
    const { t } = useTranslation();

    const getTypeLabel = (record: SubjectReviewLogAuditRecord) => {
        if (isEmpty(record)) return '';
        if (record.Type === 0) return t('auditLog:system');
        if (record.Type === 2) return t('auditLog:note');
        return t('auditLog:manual');
    };

    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              ...removePropertiesFromObject(oldRecord, fieldsToHide),
              Type: getTypeLabel(oldRecord),
              Dataset: oldRecord.DataSetDate,
          }
        : oldRecord;

    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              ...removePropertiesFromObject(newRecord, fieldsToHide),
              Type: getTypeLabel(newRecord),
              Dataset: newRecord.DataSetDate,
          }
        : newRecord;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field }),
    );

    return <FieldChangeGrid items={items} />;
};

export default SubjectReviewLogsAuditLogGrid;
